module.exports = __webpack_public_path__ + "assets/img/second.ae154259.png";